import apiService from '../utils/apiService';
import {
  ADD_COMPLEMENT_SIGNET,
  ADD_COMPLEMENT_SIGNET_START,
  ADD_COMPLEMENT_SIGNET_ERROR,
  GET_COMPLEMENT_SIGNET_LAST,
  GET_COMPLEMENT_SIGNET_LAST_START,
  GET_COMPLEMENT_SIGNET_LAST_ERROR,
  GET_COMPLEMENT_SIGNET_LIST_BY_SIGNET,
  GET_COMPLEMENT_SIGNET_LIST_BY_SIGNET_START,
  GET_COMPLEMENT_SIGNET_LIST_BY_SIGNET_ERROR,
  CLEAR_COMPLEMENT_SINGET,
} from './types';
import {
  complementSignetAddPath,
  complementSignetFindLastBySignetPath,
  complementSignetFindAllBySignetIdPath,
} from '../constants/apiEndpoints';
import {
  notificationTypeError,
  notificationTypeSuccess,
} from '../constants/globals';
import { createNotification } from '../utils';

const addComplementSignetStart = () => {
  return {
    type: ADD_COMPLEMENT_SIGNET_START,
  };
};

const addComplementSignetSuccessfully = (data) => {
  return {
    type: ADD_COMPLEMENT_SIGNET,
    payload: data,
  };
};
const addComplementSignetUnsuccessfully = (err) => {
  return {
    type: ADD_COMPLEMENT_SIGNET_ERROR,
    payload: err,
  };
};

const getLastComplementSignetStart = () => {
  return {
    type: GET_COMPLEMENT_SIGNET_LAST_START,
  };
};
const getLastComplementSignetSuccessfully = (data) => {
  return {
    type: GET_COMPLEMENT_SIGNET_LAST,
    payload: data,
  };
};
const getLastComplementSignetUnsuccessfully = (err) => {
  return {
    type: GET_COMPLEMENT_SIGNET_LAST_ERROR,
    payload: err,
  };
};

const getComplementSignetListBySignetStart = () => {
  return {
    type: GET_COMPLEMENT_SIGNET_LIST_BY_SIGNET_START,
  };
};
const getComplementSignetListBySignetSuccessfully = (data) => {
  return {
    type: GET_COMPLEMENT_SIGNET_LIST_BY_SIGNET,
    payload: data,
  };
};
const getComplementSignetListBySignetUnsuccessfully = (err) => {
  return {
    type: GET_COMPLEMENT_SIGNET_LIST_BY_SIGNET_ERROR,
    payload: err,
  };
};

const clearComplementSignetContent = () => {
  return {
    type: CLEAR_COMPLEMENT_SINGET,
  };
};

export const createComplementSignet = (complementSignet, callback, message) => {
  return (dispatch) => {
    dispatch(addComplementSignetStart());
    return apiService
      .post(complementSignetAddPath(), complementSignet)
      .then((response) => {
        dispatch(addComplementSignetSuccessfully(response.data));
        callback();
        createNotification(
          notificationTypeSuccess,
          message.complementationSignet,
          message.successComplementRequired
        );
      })
      .catch((err) => {
        dispatch(addComplementSignetUnsuccessfully(err?.response?.data));
        createNotification(
          notificationTypeError,
          message.complementError,
          err?.response?.data?.message
        );
      });
  };
};

export const findLastComplementSignetBySignetId = (id) => {
  return (dispatch) => {
    dispatch(getLastComplementSignetStart());
    return apiService
      .get(complementSignetFindLastBySignetPath(id))
      .then((response) => {
        dispatch(getLastComplementSignetSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getLastComplementSignetUnsuccessfully(err?.response?.data));
      });
  };
};

export const findComplementSignetListBySignetId = (id) => {
  return (dispatch) => {
    dispatch(getComplementSignetListBySignetStart());
    return apiService
      .get(complementSignetFindAllBySignetIdPath(id))
      .then((response) => {
        dispatch(getComplementSignetListBySignetSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(
          getComplementSignetListBySignetUnsuccessfully(err?.response?.data)
        );
      });
  };
};

export const clearComplementSignet = () => {
  return (dispatch) => {
    dispatch(clearComplementSignetContent());
  };
};
